import React from "react";
import ResumeUseForm from "../../hooks/editor/resumeUseForm";
import EditorInput from "../../Components/Inputs/EditorInput";
import "./CoverEditor.scss";

function AddressForm({
  title,
  sectionId,
  resumeFields,
  setResumeFields,
  handleEditorChange,
  resumeUpdate,
  resumeHandler,
  changeHeaderSettings,
}) {
  return (
    <div className="card pb-5 mb-4 ">
      <div className="card-header d-flex justify-content-between align-items-center bg-white">
        <h4 className="card-title">{title}</h4>
      </div>
      {resumeFields && resumeFields.from && sectionId && sectionId == "from" ? (
        <>
          <div className="">
            <div className="col-md-12 ">
              <div className="row mt-3">
                <div className="col-md-6 col-12 col-sm-12 mb-3">
                  <EditorInput
                    label="Full Name"
                    value={
                      resumeFields &&
                      resumeFields.from &&
                      resumeFields.from.name
                    }
                    name="name"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
                <div className="col-md-6 col-12 col-sm-12 mb-3">
                  <EditorInput
                    label="Job Title"
                    value={
                      resumeFields &&
                      resumeFields.from &&
                      resumeFields.from.jobTitle
                    }
                    name="jobTitle"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
                <div className="col-md-6 col-12 col-sm-12 mb-3">
                  <EditorInput
                    label="Email"
                    value={
                      resumeFields &&
                      resumeFields.from &&
                      resumeFields.from.email
                    }
                    name="email"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
                <div className="col-md-6 col-12 col-sm-12 mb-3 ">
                  <EditorInput
                    label="Phone"
                    value={
                      resumeFields &&
                      resumeFields.from &&
                      resumeFields.from.phone
                    }
                    name="phone"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>

                <div className="col-md-6 col-12 col-sm-12 mb-3 ">
                  <EditorInput
                    label="City"
                    value={
                      resumeFields &&
                      resumeFields.from &&
                      resumeFields.from.city
                    }
                    name="city"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
                <div className="col-md-6 col-12 col-sm-12 mb-3 ">
                  <EditorInput
                    label="Website"
                    value={
                      resumeFields &&
                      resumeFields.from &&
                      resumeFields.from.website
                    }
                    name="website"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="">
            <div className="col-md-12 ">
              <div className="row mt-3">
                <div className="col-md-6 col-12 col-sm-12 mb-3">
                  <EditorInput
                    label="Company Name"
                    value={
                      resumeFields &&
                      resumeFields.to &&
                      resumeFields.to.companyName
                    }
                    name="companyName"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
                <div className="col-md-6 col-12 col-sm-12 mb-3 ">
                  <EditorInput
                    label="Hiring Manager Name"
                    value={
                      resumeFields && resumeFields.to && resumeFields.to.hr_name
                    }
                    name="hr_name"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
                <div className="col-md-6 col-12 col-sm-12 mb-3 ">
                  <EditorInput
                    label="Company Address"
                    value={
                      resumeFields &&
                      resumeFields.to &&
                      resumeFields.to.companyAddress
                    }
                    name="companyAddress"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
                <div className="col-md-6 col-12 col-sm-12 mb-3 ">
                  <EditorInput
                    label="City"
                    value={
                      resumeFields && resumeFields.to && resumeFields.to.city
                    }
                    name="city"
                    autoComplete="off"
                    className={`form-control`}
                    onChange={(e) => resumeHandler(e, 0, "basic", sectionId)}
                    onBlur={resumeUpdate}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default AddressForm;
